import request from '@/utils/request'
import { postFetch } from '@/utils/request'

// const commonApiBaseUrl = `https://www.livecourse.com/api/simple-class`
const commonApiBaseUrl = `https://simple-class-admin.zhihuishu.com/simple-class`

// 获取所有大屏的信息
const getAdminScreenPage = (params) => {
    return request({
        // baseURL: commonApiBaseUrl,
        url: `/admin/screen/getAdminScreenPage`,
        method: 'post',
        params
    })
}
// 新增大屏页面
const addScreenPage = (params) => {
    return request({
        // baseURL: commonApiBaseUrl,
        url: `/admin/screen/insertScreenPage`,
        method: 'post',
        params
    })
}

// 删除大屏页面
const delScreenPage = (params) => {
    return request({
        // baseURL: commonApiBaseUrl,
        url: `admin/screen/deleteScreenPageById`,
        method: 'post',
        params
    })
}

const batchUpdateScreen = (params, config) => {
    return postFetch(`${commonApiBaseUrl}/admin/screen/batchUpdate`, params, config)
} 

export default {
    getAdminScreenPage,
    addScreenPage,
    batchUpdateScreen,
    delScreenPage
}
